export default __webpack_public_path__ + "static/media/Pyramide-besoins_perso_n1_physiologiques.d1587462.svg";